export const DEFAULT_INSTRUCTION =
  "Inject {{units}} units ({{dosage}}) SQ once a week for 4 weeks and discard any remaining.";
